import axios from 'axios';
import type {
  IGetUserDocumentListParams,
  IGetUserDocumentListRequest,
  IGetUserDocumentListResponse,
} from '@/app-package';

const getUserDocumentList = async (params: IGetUserDocumentListParams) => {
  const config: IGetUserDocumentListRequest = {
    url: `/supra/document_list/${params.userBillingNumber}`,
    method: 'get',
  };
  try {
    const { data } = await axios.request<IGetUserDocumentListResponse>(config);
    return data;
  } catch (error: any) {
    // Check for 404 error and return a nulled object
    if (error.response && error.response.status === 404) {
      return [];
    }
    throw error;
  }
};

export default getUserDocumentList;
